export enum EvasysLoadingStrategiesEnum {
	STATEONLY = 'StateOnly',
	APIONLY = 'APIOnly',
	STATETHENAPI = 'StateThenAPI',
	APITHENSTATE = 'APIThenState',
	STATEFALLBACKAPI = 'StateFallbackAPI',
}
